export default class DependenteRecad {
  constructor(
    id = null,
    nome = '',
    dataNascimento = '',
    tipo = { descricao: '' },
    sexo = '',
  ) {
    this.id = id;
    this.nome = nome;
    this.dataNascimento = dataNascimento;
    this.tipo = tipo;
    this.sexo = sexo;
  }
}



// WEBPACK FOOTER //
// ./src/domain/dependenteRecad/DependenteRecad.js